module.exports = __webpack_public_path__ + "static/media/YF59_1.53ed084e.jpg";